import { render, staticRenderFns } from "./CrudNew.vue?vue&type=template&id=b9ace4dc&scoped=true"
import script from "./CrudNew.vue?vue&type=script&lang=js"
export * from "./CrudNew.vue?vue&type=script&lang=js"
import style0 from "./CrudNew.vue?vue&type=style&index=0&id=b9ace4dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ace4dc",
  null
  
)

export default component.exports